import { useState } from 'react';
import { StickyContainer, Modal } from '@care/react-component-lib';
import { type Theme, Box, keyframes } from '@mui/material';
import { Keyframes } from '@emotion/react';
import { Filters } from './Filters';
import { FiltersCTA } from './FiltersCTA';

type FiltersModalProps = {
  isVisible: boolean;
};

const fadeInUp: Keyframes = keyframes`
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const FiltersModal = ({ isVisible }: FiltersModalProps) => {
  const animationDuration = 0.5;
  const [openFiltersModal, setOpenFiltersModal] = useState(false);

  const handleCloseModal = () => {
    setOpenFiltersModal(false);
  };

  return (
    <>
      <StickyContainer sx={{ background: 'transparent' }}>
        <Box
          className={isVisible ? 'show-filters-modal' : 'hide-filters-modal'}
          sx={{
            opacity: 0,
            position: 'relative',
            '&.hide-filters-modal': {
              animation: 'none',
            },
            '&.show-filters-modal': {
              animation: `${fadeInUp} ${animationDuration}s ease-out forwards`,
            },
          }}>
          <FiltersCTA setOpenFiltersModal={setOpenFiltersModal} />
        </Box>
      </StickyContainer>
      <Modal
        open={openFiltersModal}
        onClose={handleCloseModal}
        hideClose
        aria-labelledby="listing-page-filters-modal"
        sx={(theme: Theme) => ({
          '& .MuiDialogContent-root': {
            paddingBottom: 0,
          },
          '& .MuiDialog-paper': {
            [theme.breakpoints.down('md')]: {
              padding: theme.spacing(3),
              margin: 0,
              top: 0,
              width: '100%',
              minWidth: 'unset',
              maxWidth: 'unset',
              height: '100%',
              maxHeight: '100%',
              borderRadius: '0px',
            },
          },
        })}
        variant="dynamic">
        <Filters setOpenFiltersModal={setOpenFiltersModal} />
      </Modal>
    </>
  );
};

export { FiltersModal };
